import { dehydrate, QueryClient } from '@tanstack/react-query';
import { Home as HomePage } from 'components/pages/Home';
import { fetchHome, HOME_PAGE_KEY } from 'hooks/pages/useHome';
import { fetchPosts, POSTS_KEY } from 'hooks/usePosts';
import { prefetchCommonData } from 'utils/buildTime';

export async function getStaticProps() {
  const queryClient = new QueryClient();

  await prefetchCommonData(queryClient);

  await queryClient.prefetchQuery({
    queryKey: [POSTS_KEY, 5, null, null],
    queryFn: fetchPosts,
  });

  await queryClient.prefetchQuery({
    queryKey: [HOME_PAGE_KEY],
    queryFn: fetchHome,
  });

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
}

export default function Home() {
  return <HomePage />;
}
